import type { FaireProductEntity } from "../../entity_types/product";

export const p_gguhqyk99k: FaireProductEntity = {
  token: "p_gguhqyk99k",
  type: "product",
  name: "Tan Bandana Fringe Vest",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/1bc44747cf36b06bba9d51e8fa10c2287ba9657d4fb0c1a2a28f3d37a785daab.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b1321fb620ab2c9a56b707cf2c57d6358ac07969b40860589da289db503fdd78.jpeg",
    "https://cdn.faire.com/fastly/330ea9fb75974af5d0d0b3df104549e2205d844a0020736df5121fe0b527cec3.jpeg",
    "https://cdn.faire.com/fastly/33b339a0060360623a5eab6073990f45aec8a70d02bc86977a26a299c3adbd12.jpeg",
    "https://cdn.faire.com/fastly/3a3ada43d987615f74331100d03d42c71e43c418c517f62949622356e9d0f1c7.jpeg"
  ],
  priceDollars: 33.95,
  description: "Tan Bandana Fringe Vest featuring an allover black bandana-inspired pattern, designed with an open front, self-tie waist closure, two front pockets, sleeveless silhouette, and long fringe trim along the front and hem. Finished in a soft knit fabric with a relaxed fit for easy western-inspired layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:46.255Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
